import {IController, IPromise, IQService, IScope} from "angular";
import {Cursor} from "../../utils/models/Page";
import {OpportunityLog} from "../../opportunities/model/Opportunity";
import {OpportunityFilterUi} from "../../opportunities_filter/model/OpportunityFilterUi";
import {CalculationsLogServiceName} from "../../utils/names/serviceNames";
import {CalculationsLogService} from "../../logging_lqb_funded/services/CalculationsLogService";
import {Calculator, CalculatorName} from "../../calculations/model/Calculator";


interface LoggingControllerScope extends IScope {
    fetchCalculationsLogs: (nextCursor?: number,beforeCursor?: number) => IPromise<OpportunityLog[]>;
    onFilterValueChange: (filterVal: OpportunityFilterUi) => void;
    logs: OpportunityLog[];
    pagingConfig: Cursor<OpportunityLog>;
    cancelCall: () => void;
    showLoader: boolean;
}

export class LoggingController implements IController {

    static instance = ['$scope', '$q', CalculationsLogServiceName, LoggingController];

    loggingService: CalculationsLogService;

    $scope: LoggingControllerScope;

    filterVal: OpportunityFilterUi;

    $q: IQService;

    constructor($scope: LoggingControllerScope,
                $q: IQService,
                loggingService: CalculationsLogService) {
        this.loggingService = loggingService;
        this.$scope = $scope;
        this.$q = $q;
        $scope.pagingConfig = {pageSize: 10, fetchPage: this.refreshLogs};
        $scope.onFilterValueChange = this.onFilterValueChange;
        $scope.fetchCalculationsLogs = this.fetchCalculationsLogs;
    }

    refreshLogs = () => this.onFilterValueChange(this.filterVal);

    onFilterValueChange = (filterVal: OpportunityFilterUi) :IPromise<OpportunityLog[]> => {
        this.$scope.pagingConfig.hasBefore = false;
        if (!filterVal.isSuccess) {
            //means that filter should not be applied when isSuccess is false rather then
            delete filterVal['isSuccess'];
        }
        this.filterVal = filterVal;
        let promise = this.fetchCalculationsLogs();
        promise.then(() => {
        if (this.$scope.logs.length > this.$scope.pagingConfig.pageSize) {    // <- first load case !important for cursor pagination!
                this.$scope.pagingConfig.hasNext = true;
                this.$scope.logs.pop();
            }
        })
        return promise;
    };

    fetchCalculationsLogs = (nextCursor?: number, beforeCursor?: number) => {
        this.$scope.showLoader = true;
        let canceler = this.$q.defer();
        let $scope = this.$scope;
        if ($scope.cancelCall !== undefined) {
            $scope.cancelCall();
        }
        let pageSize = $scope.pagingConfig.pageSize;
        let promise = this.loggingService.getAllLogsPage(pageSize, this.filterVal, canceler, nextCursor, beforeCursor)
            .then(resp => {
                let logsPage = resp.data;
                if (logsPage == null) {
                   return null;
                }
                logsPage.forEach(log => {
                    log.imageUrl = Calculator.getImageUrl(log.calculatorName as CalculatorName);
                });
                $scope.logs = logsPage;
                this.$scope.showLoader = false;
                return logsPage;
            });
        $scope.cancelCall = function(){
            canceler.resolve();
        }
        return promise;
    };
}